import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const login = (email: string, password: string) =>
  api.post('/auth/login', { email, password });

export const register = (email: string, username: string, password: string) =>
  api.post('/auth/register', { email, username, password });

export const getMe = () => api.get('/auth/me');

// Books
export const getBooks = () => api.get('/books');
export const getBook = (id: number) => api.get(`/books/${id}`);
export const getChapters = (bookId: number) => api.get(`/books/${bookId}/chapters`);
export const getChapter = (bookId: number, chapterId: number) =>
  api.get(`/books/${bookId}/chapters/${chapterId}`);

// Poems
export const getPoems = () => api.get('/poems');
export const getPoem = (id: number) => api.get(`/poems/${id}`);

// Stories
export const getStories = () => api.get('/stories');
export const getStory = (id: number) => api.get(`/stories/${id}`);

// Admin
export const getUsers = () => api.get('/admin/users');
export const getStats = () => api.get('/admin/stats');

// Admin listings (include drafts)
export const getAdminBooks = () => api.get('/admin/books');
export const getAdminPoems = () => api.get('/admin/poems');
export const getAdminStories = () => api.get('/admin/stories');

export const createBook = (data: any) => api.post('/admin/books', data);
export const updateBook = (id: number, data: any) => api.put(`/admin/books/${id}`, data);
export const deleteBook = (id: number) => api.delete(`/admin/books/${id}`);
export const createChapter = (bookId: number, data: any) =>
  api.post(`/admin/books/${bookId}/chapters`, data);
export const updateChapter = (id: number, data: any) => api.put(`/admin/chapters/${id}`, data);
export const deleteChapter = (id: number) => api.delete(`/admin/chapters/${id}`);

export const createPoem = (data: any) => api.post('/admin/poems', data);
export const updatePoem = (id: number, data: any) => api.put(`/admin/poems/${id}`, data);
export const deletePoem = (id: number) => api.delete(`/admin/poems/${id}`);

export const createStory = (data: any) => api.post('/admin/stories', data);
export const updateStory = (id: number, data: any) => api.put(`/admin/stories/${id}`, data);
export const deleteStory = (id: number) => api.delete(`/admin/stories/${id}`);

// Forum
export const getThreads = () => api.get('/forum/threads');
export const getThread = (id: number) => api.get(`/forum/threads/${id}`);
export const createThread = (data: { title: string; body: string }) =>
  api.post('/forum/threads', data);
export const createReply = (threadId: number, data: { body: string }) =>
  api.post(`/forum/threads/${threadId}/replies`, data);
export const deleteThread = (id: number) => api.delete(`/forum/threads/${id}`);
export const deleteReply = (id: number) => api.delete(`/forum/replies/${id}`);

export const uploadFile = (file: File, category: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);
  return api.post('/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default api;
